import { pick } from 'ramda';
import { useEffect, useState } from 'react';

export const useLoadImage = ({ action: { imageUrl } }) => {
    const [imageInfo, addImageInfo] = useState(null);

    useEffect(() => {
        if (!imageUrl) {
            return;
        }

        const image = document.createElement('img');
        const error = new Error('Image load error.');

        image.onload = () => addImageInfo(pick(['width', 'height'], image));
        image.onerror = () => addImageInfo({ error });

        image.src = imageUrl;
    }, [imageUrl]);

    return imageInfo;
};
